import value from '../assets/scss/_themes-vars.module.scss';
import { amber, lightBlue } from '@material-ui/core/colors'
import { purple } from '@material-ui/core/colors';
/**
 * MUI Componets whose styles are overrided as per theme
 */
export function componentStyleOverrides(theme) {
    return {
        MuiCssBaseline: {
            '@global': {
                'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none !important',
                    margin: '0 !important',
                },
                'input[type=number]': {
                    MozAppearance: 'textfield !important',
                    appearance: 'textfield !important',
                },
            },
        },
        MuiButton: {
            root: {
                textTransform: 'uppercase',
                borderRadius: theme.customization.borderRadius + 'px',
            },
            contained: {
                backgroundColor: amber[500],
                '&:hover': { // changes colors for hover state
                    backgroundColor: amber[600],
                },
            },
        },
        MuiPaper: {
            root: {
                backgroundImage: 'none',
                elevation: 0
            },
            rounded: {
                //border: '1px solid',
                borderColor: theme.customization.navType === 'dark' ? lightBlue[200] : purple[300],
                borderRadius: theme.customization.borderRadius + 'px',
                elevation: 0
            }

        },

        MuiCardHeader: {
            root: {
                padding: 0,
                backgroundColor: theme.customization.navType === 'dark' ? lightBlue[800] : purple[300],
            },
            action: {
                marginTop: 0,
                marginBottom: 0,
                marginRight: 0
            },
            content : {
               height: '2.5rem',
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center', 
            }
        },
        MuiCardContent: {
            root: {

            }

        },
        MuiCardActions: {
            root: {
                margin: 0
            }
        },
        MuiAlert: {
            root: {
                alignItems: 'center'
            }
        },
        MuiButtonBase: {
            root: {
                '&.MuiListItem-root': {
                    color: theme.textPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                },
                '&.MuiOutlinedInput-root': {
                    //borderRadius: customization.borderRadius + 'px'
                }
            }
        },
        MuiListItemIcon: {
            root: {
                color: theme.textPrimary,
                minWidth: '36px'
            }
        },
        MuiListItemText: {
            primary: {
                color: theme.textDark
            }
        },
        MuiInputBase: {
            input: {

                '&::placeholder': {
                    color: theme.textSecondary,
                    fontSize: '0.875rem'
                }
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: theme.customization.borderRadius + 'px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.customization.navType === 'dark' ? value.textPrimary : value.grey400
                },
                '&.Mui-disabled': {
                    backgroundColor: theme.customization.navType === 'dark' ? value.textPrimary : value.grey50
                }
            },
            input: {
                padding: '15.5px 14px',
            },
            inputAdornedStart: {
                paddingLeft: 4
            },
            notchedOutline: {
                borderRadius: theme.customization.borderRadius + 'px'
            }

        },
        MuiSlider: {
            root: {
                '&.Mui-disabled': {
                    color: theme.customization.navType === 'dark' ? value.textPrimary + 50 : value.grey300
                }
            },
            mark: {
                backgroundColor: theme.paper,
                width: '4px'
            }
        },
        MuiAutocomplete: {

            root: {
                '& .MuiAutocomplete-tag': {
                    background: theme.customization.navType === 'dark' ? value.textPrimary + 20 : value.deepPurple50,
                    borderRadius: 4,
                    color: theme.textDark,
                    '.MuiChip-deleteIcon': {
                        color: theme.customization.navType === 'dark' ? value.textPrimary + 80 : value.deepPurple200
                    }
                }
            },
            popper: {
                borderRadius: theme.customization.borderRadius + 'px',
                boxShadow: '0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)'
            }

        },
        MuiDivider: {


        },
        MuiSelect: {

            select: {
                '&:focus': {
                    backgroundColor: 'transparent'
                }
            }

        },
        MuiCheckbox: {

            select: {
                fontSize: '28px'
            }
            ,
            MuiSvgIcon: {
                styleOverrides: {
                    select: {
                        borderRadius: '6px',
                        width: '1.2em',
                        height: '1.2em'
                    }
                }
            }
        },
        MuiAvatar: {

            root: {
                color: theme.customization.navType === 'dark' ? value.darkLevel1 : value.blue600,
                background: theme.customization.navType === 'dark' ? theme.textPrimary : value.blue200
            }

        },
        MuiChip: {

            root: {
                '&.MuiChip-deletable .MuiChip-deleteIcon': {
                    color: 'inherit'
                }
            }

        },
        MuiTimelineContent: {

            root: {
                color: theme.textDark,
                fontSize: '16px'
            }

        },
        MuiTreeItem: {

            label: {
                marginTop: 8,
                marginBottom: 8
            }

        },
        MuiTimelineDot: {

            root: {
                boxShadow: 'none'
            }

        },
        MuiDateTimePickerTabs: {

            tabs: {
                backgroundColor: value.blue50,
                '& .MuiTabs-scroller': {
                    '& .MuiTabs-flexContainer .MuiButtonBase-root.MuiTab-textColorPrimary': {
                        color: theme.textDark,
                        '&.Mui-selected': {
                            color: theme.customization.navType === 'dark' ? value.darkLevel1 : value.blue600
                        }
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: value.blue500
                    }
                }
            }

        },
        MuiClock: {

            root: {
                '& .MuiIconButton-root': {
                    padding: '4px',
                    bottom: '14px',
                    '& .MuiIconButton-label .MuiTypography-root': {
                        color: theme.textDark,
                        fontSize: '0.625rem'
                    },
                    '&.MuiClock-meridiemButtonSelected': {
                        backgroundColor: theme.customization.navType === 'dark' ? value.darkLevel1 : value.blue600,
                        '& .MuiIconButton-label .MuiTypography-root': {
                            color: theme.paper
                        }
                    }
                }
            }

        },
        MuiDialog: {

            paper: {
                padding: '12px 12px 12px 0'
            }

        },

    };
}
